export { useStores } from './root-store';

export type { RootStore } from './root-store';
export { DefaultState } from './root-store';
export { useAuthStore } from './auth-store';
export { useRootStore } from './root-store/setup-root-store';
